// HeaderGB.js
import React, { useEffect, useState } from 'react';
import { Header } from 'antd/lib/layout/layout';
import { Row, Col, Tooltip } from 'antd';
import { Link, useLocation, useParams, useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../../../../assets/icons/logo.gov.svg';
import { ReactComponent as Greece2 } from '../../../../assets/icons/logo.greece2.gov.svg';
import { ReactComponent as BarChart } from '../../../../assets/icons/reports.gov.svg';
//import { ReactComponent as Download } from '../../../../assets/icons/download.gov.svg';
import { ReactComponent as UserManualIcon } from '../../../../assets/icons/user-manual-icon.svg';
import { ReactComponent as FaqIcon } from '../../../../assets/icons/faq-icon.svg';
import { ReactComponent as SBGrowth } from '../../../../assets/icons/sbgrowthWhite.svg';
import { Logout } from './components';
import { useSelector, useDispatch } from 'react-redux';
import { getSystemLocales } from 'store/forms/actions';
import { RenderButtons } from 'components/layout/utils';
import { saveTask, submitTask, startNew } from 'store/forms/actions';
import SubmitModal from '../submitModal';
import InvalidModal from '../invalidModal';
import { getLocalString, localNames } from 'utils/localisation.service';
import {
  handleSubmit,
  isKtP,
  isBeneficiary,
  isProvider,
  isUserStore,
  isMinistry,
  isCoe,
} from 'utils';
import Button from 'components/button';
import {
  openUploadOffersModal,
  openMassUploadSubmitModal,
  getBannerInfo,
} from 'store/appTrack/actions';
import { checkUniqueness } from 'store/forms/actions';
import { handleCheckUniqueness } from 'utils';
import ApproveModal from '../approveModal';
import RejectModal from '../rejectModal';
import ReturnToCoeModal from '../returnToCoeModal';
import userManualBeneficiary from '../../../../assets/documents/User Manual - Αιτών.docx';
import userManualCoe from '../../../../assets/documents/User Manual - Αξιολογητής.docx';
import userManualMinistry from '../../../../assets/documents/User Manual - Χρήστης Υπουργείου.docx';

const HeaderGB = props => {
  const location = useLocation();
  const [visible, setVisible] = useState(false);
  const [viewformSubmitVisible, setViewformSubmitVisible] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isApproveVisible, setIsApproveVisible] = useState(false);
  const [isRejectVisible, setIsRejectVisible] = useState(false);
  const [isReturnToCoeVisible, setIsReturnToCoeVisible] = useState(false);
  const [userManual, setUserManual] = useState('');
  const user = useSelector(state => state.user);
  const privileges = user.privileges;
  const groups = user.groups;
  const submitDisabled = useSelector(state => state.forms.submitting);
  const [outcome, setOutcome] = useState('');
  const params = useParams();
  const state = useSelector(state => state.forms);
  const variablesIndexed = useSelector(
    state => state.appTrack?.apptrackDetails?.variablesIndexed
  );
  const formId = useSelector(state => state.forms.formId);
  const task = useSelector(state => state.forms.task);
  const viewMode = useSelector(state => state.forms.carrier?.viewMode);
  const dispatch = useDispatch();
  const applStatus = useSelector(state => state.forms.applStatus);
  const navigate = useNavigate();
  const locales = useSelector(state => state.forms?.localeStrings);
  const offersFile = useSelector(state => state.appTrack?.selectedOffersFile);
  const banner = useSelector(state => state.appTrack?.banner);
  const providerFile = useSelector(
    state => state.appTrack?.selectedMassUploadFile
  );
  const providerDoc = useSelector(
    state => state.forms.documents?.contractProvider
  );
  const activeTaskName = useSelector(state =>
    location.pathname.includes('apptrack')
      ? state.appTrack.apptrackDetails?.activeTaskName
      : state.forms.task.taskName
  );
  const procInstId = useSelector(state =>
    location.pathname.includes('apptrack')
      ? state.appTrack.apptrackDetails?.id
      : state.forms.task.processInstanceId
  );
  const activeTaskId = useSelector(
    state => state.appTrack.apptrackDetails?.activeTaskId
  );

  const lockSubmitBanner = useSelector(state => state.appTrack?.banner);
  const [invalidModalVisible, setInvalidModalVisible] = useState(false);

  const [rejectReasons, setRejectReasons] = useState({});
  const businessKey = useSelector(
    state => state.appTrack?.apptrackDetails?.businessKey
  );
  const [errorModal, setErrorModal] = useState(false);
  const [errorMessages, setErrorMessages] = useState('');

  const logoLink = user => {
    if (window.location.pathname.includes('map')) return '/';
    if (!user?.status) {
      return '/login';
    }
    if (isUserStore(groups)) {
      return '/reports';
    }
    return '/appTrack';
  };

  // Retrieve language from localStorage or use default
  const storedLanguage =
    localStorage.getItem('appLanguage') ||
    process.env.REACT_APP_DEFAULT_APP_LANGUAGE;
  const [language, setLanguage] = useState(storedLanguage);

  useEffect(() => {
    dispatch(getSystemLocales(language));
  }, [language, dispatch]);

  // Update localStorage whenever the language changes
  useEffect(() => {
    localStorage.setItem('appLanguage', language);
  }, [language]);

  //UNCOMMENT TO ADD USER MANUALS

  useEffect(() => {
    if (user?.status === 200) {
      if (isBeneficiary(user?.groups)) {
        setUserManual({
          title: 'User Manual - Αιτών.docx',
          docLink: userManualBeneficiary,
        });
      } else if (isCoe(user?.groups)) {
        setUserManual({
          title: 'User Manual - Αξιολογητής.docx',
          docLink: userManualCoe,
        });
      } else if (isMinistry(user?.groups)) {
        setUserManual({
          title: 'User Manual - Χρήστης Υπουργείου.docx',
          docLink: userManualMinistry,
        });
      } else {
        setUserManual(null);
      }
    }
  }, [user]);
  const handleLanguageChange = lang => {
    setLanguage(lang);
  };

  return (
    <Header id="main-header" className="app-layout__header">
      <ApproveModal
        id="header-submit-modal"
        isApproveVisible={isApproveVisible}
        setIsApproveVisible={setIsApproveVisible}
        submitDisabled={submitDisabled}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            variablesIndexed: { ...variablesIndexed },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsApproveVisible,
            setErrorModal,
            setErrorMessages,
            taskId: activeTaskId,
            formId,
            formKey: task.formKey,
            outcome,
            task: { ...task, taskName: activeTaskName },
          })
        }
      />
      <InvalidModal
        id="header-submit-modal"
        isVisible={errorModal}
        setIsVisible={setErrorModal}
        errorMessages={errorMessages}
        capex={true}
        formKey={task.formKey}
        taskId={params.taskId}
        businessKey={businessKey}
      />
      <RejectModal
        id="header-submit-modal"
        isVisible={isRejectVisible}
        setIsVisible={setIsRejectVisible}
        submitDisabled={submitDisabled}
        formKey={task.formKey}
        outcome={outcome}
        taskId={params.taskId}
        businessKey={businessKey}
        handleSubmit={rejectMessage =>
          handleSubmit({
            state: { ...state },
            variablesIndexed: { ...variablesIndexed },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible: setIsRejectVisible,
            taskId: activeTaskId,
            formId,
            formKey: task.formKey,
            outcome,
            rejectMessage,
            task: { ...task, taskName: activeTaskName },
          })
        }
      />
      <SubmitModal
        id="header-submit-modal"
        isVisible={isVisible}
        setIsVisible={setIsVisible}
        submitDisabled={submitDisabled}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            setErrorModal,
            setErrorMessages,
            taskId: params.taskId,
            activeTaskName: activeTaskName,
            procInstId: procInstId,
            formId,
            formKey: task.formKey,
            outcome,
            task,
            modal: true,
          })
        }
      />
      <SubmitModal
        id="header-submit-modal"
        isVisible={viewformSubmitVisible}
        setIsVisible={setViewformSubmitVisible}
        submitDisabled={submitDisabled}
        formKey={task.formKey}
        outcome={outcome}
        handleSubmit={() =>
          handleSubmit({
            state: { ...state },
            variablesIndexed: { ...variablesIndexed },
            user: { ...user },
            dispatch,
            submitTask,
            navigate,
            setIsVisible,
            setErrorModal,
            setErrorMessages,
            taskId: activeTaskId,
            activeTaskName: activeTaskName,
            procInstId: procInstId,
            formId,
            formKey: task.formKey,
            outcome,
            task: { ...task, taskName: activeTaskName },
          })
        }
      />
      <ReturnToCoeModal
        id="header-return-to-coe-modal"
        isVisible={isReturnToCoeVisible}
        setIsVisible={setIsReturnToCoeVisible}
        outcome={outcome}
        businessKey={businessKey}
        handleSubmit={returnMessage =>
          handleSubmit({
            state: { ...state },
            variablesIndexed: { ...variablesIndexed },
            user: { ...user },
            dispatch,
            submitTask,
            setErrorModal,
            setErrorMessages,
            navigate,
            taskId: activeTaskId,
            formId,
            formKey: task.formKey,
            outcome,
            rejectMessage: returnMessage,
            task: { ...task, taskName: activeTaskName },
          })
        }
      />
      <InvalidModal
        id="header-reject-modal"
        isVisible={invalidModalVisible}
        setVisible={setInvalidModalVisible}
        rejectReasons={rejectReasons}
        setRejectReasons={setRejectReasons}
      />
      <Row>
        <Col span={24} className="logo-header-inner">
          <div id="header-logos">
            <div className="sbgrowth-wrapper">
              <Link to={logoLink(user)}>
                <SBGrowth></SBGrowth>
              </Link>
            </div>
            {/* <Logo className="app-layout__logo" /> */}
            <a
              href="https://www.gov.gr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Logo />
            </a>
            <Greece2 />
            {user?.userId === 'admin' && (
              <span style={{ fontSize: '1rem', color: 'white' }}>v0.1</span>
            )}
          </div>

          <div className="header-icons">
            <div id="language-menu">
              {/* <Globe className="colored-svg white" /> */}
              {/* <div className="header-icon">
                <div
                  className={`nav-titles ${
                    language === 'GR' ? 'selected' : ''
                  }`}
                  onClick={() => handleLanguageChange('GR')}
                >
                  gr
                </div>
              </div>*/}
              {/* <Divider type="vertical" lineWidth="3" /> */}
              {/* <div className="header-icon">
                <div
                  className={`nav-titles ${
                    language === 'UK' ? 'selected' : ''
                    }`}
                  onClick={() => handleLanguageChange('UK')}
                >
                  en
                </div>
              </div> */}
              {/* <Switch checked={language === 'GR'} checkedChildren="GR" unCheckedChildren="UK" onChange={(checked) => {if (checked) {
                handleLanguageChange('GR')
              }else {
                handleLanguageChange('UK')
              }}}/> */}
            </div>
            {!isBeneficiary(groups) &&
              !isUserStore(groups) &&
              user.status !== null &&
              user.status !== 400 && (
                <div
                  id="reports-icon"
                  className="header-icon container"
                  onClick={() => {
                    navigate('/reports');
                  }}
                >
                  <Tooltip title="Reports">
                    <BarChart />
                  </Tooltip>
                </div>
              )}
            {user.status !== null &&
              user.status !== 400 &&
              !location.pathname.includes('main-forms') && (
                <div className="header-icon-group">
                  <Link to="/faq" target="_blank" rel="noopener noreferrer">
                    <div className="header-icon container">
                      <Tooltip title="Συχνές Ερωτήσεις">
                        <span className="icon-circle">
                          <FaqIcon className="header-svg-icon" />
                        </span>
                      </Tooltip>
                    </div>
                  </Link>
                  <a href={userManual?.docLink} download={userManual?.title}>
                    <div
                      id="user-manual-download-icon"
                      className="header-icon container"
                      onClick={() => {
                        // apptrackService.downloadUserManual(userManual);
                        console.log('Download Manual:', userManual);
                      }}
                    >
                      <Tooltip title="User Manual">
                        <span className="icon-circle">
                          <UserManualIcon className="header-svg-icon" />
                        </span>
                      </Tooltip>
                    </div>
                  </a>
                </div>
              )}
            {/* {user.status !== null &&
              user.status !== 400 &&
              location.pathname.includes('main-forms') && (
                <div
                  id="header-icon user-manual-download-icon"
                  className="header-icon container"
                  onClick={() => console.log('Notifications Button Clicked')}
                >
                  <Tooltip title="Notifications">
                    <Bell />
                  </Tooltip>
                </div>
              )} */}
            {privileges?.includes('CanRenderCreateApplicationBtn') &&
              !banner?.render &&
              location.pathname.includes('appTrack') &&
              !location.pathname.includes('offers') && (
                <Button
                  type="default"
                  id="create-application-button"
                  label="Δημιουργία ΕΣ"
                  onClick={() => {
                    // handleCheckUniqueness({
                    //   user,
                    //   dispatch,
                    //   checkUniqueness,
                    // }).then(res => {
                    //   const reasons = {
                    //     case: 'checkUniqueness',
                    //     acceptable: res.acceptable, //DEV true for easier development, do not push
                    //     responseCode: res.responseCode, //"901",//res.responseCode,
                    //   };
                    //   if (reasons.acceptable) {
                    //     dispatch(startNew(navigate));
                    //   } else {
                    //     setRejectReasons(reasons);
                    //     setInvalidModalVisible(true);
                    //   }
                    // });
                    dispatch(startNew(navigate));
                  }}
                >
                  {/* <span>
                    {getLocalString(
                      locales,
                      localNames.LOGIN_PAGE_REQUESTBUTTON
                    )}
                  </span> */}
                </Button>
              )}

            {(location.pathname.includes('main-forms') ||
              location.pathname.includes('apptrack')) && (
              <RenderButtons
                {...{
                  task,
                  state: { ...state },
                  dispatch,
                  saveTask,
                  submitTask,
                  taskId: params.taskId,
                  formId,
                  setOutcome,
                  setIsVisible,
                  setIsReturnToCoeVisible,
                  locales,
                  user: { ...user },
                  viewMode,
                  applStatus,
                  setIsApproveVisible,
                  setIsRejectVisible,
                  setInvalidModalVisible,
                  setRejectReasons,
                  providerDoc,
                  lockSubmitBanner,
                  setViewformSubmitVisible,
                  location,
                  activeTaskName,
                }}
              />
            )}
            {location.pathname.includes('viewform') && (
              <RenderButtons
                {...{
                  task,
                  state: { ...state },
                  dispatch,
                  saveTask,
                  submitTask,
                  taskId: params.taskId,
                  formId,
                  setOutcome,
                  setIsVisible,
                  setIsApproveVisible,
                  setIsRejectVisible,
                  setIsReturnToCoeVisible,
                  locales,
                  user: { ...user },
                  viewMode,
                  applStatus,
                  setInvalidModalVisible,
                  setRejectReasons,
                  providerDoc,
                  lockSubmitBanner,
                  setViewformSubmitVisible,
                  location,
                  activeTaskName,
                }}
              />
            )}
            {location.pathname.includes('appTrack') &&
              !location.pathname.includes('offers') &&
              isKtP(groups) &&
              !location.pathname.includes('payments') && (
                <div id="header-buttons-wrapper">
                  <Button
                    id="upload-offers-button"
                    type="default"
                    className="ant-btn-primary prov-offers"
                    label={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_OFFERSBUTTON
                      ) || 'Προσφορές Παρόχων'
                    }
                    disabled={false}
                    onClick={() => navigate('/appTrack/offers')}
                  />
                  <Button
                    id="payment-requests-button"
                    type="default"
                    className="ant-btn-primary submit-btn2"
                    label={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_KTP_BUTTON_CLEARANCE
                      ) || 'Μαζική Εκκαθάριση'
                    }
                    // label={'Αιτήματα Πληρωμής'}
                    disabled={false}
                    onClick={() => navigate('/appTrack/mass-payments')}
                  />
                  <Button
                    id="payment-requests-button"
                    type="default"
                    className="ant-btn-primary submit-btn"
                    label={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_KTP_BUTTON_PAYMENTS
                      ) || 'Αιτήματα Πληρωμής'
                    }
                    // label={'Αιτήματα Πληρωμής'}
                    disabled={false}
                    onClick={() => navigate('/appTrack/payments')}
                  />
                </div>
              )}
            {location.pathname.includes('offers') && isKtP(groups) && (
              <Button
                type="default"
                className="ant-btn-primary submit-btn"
                label={getLocalString(
                  locales,
                  localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                )}
                disabled={!offersFile}
                onClick={() => dispatch(openUploadOffersModal(true))}
              />
            )}
            {location.pathname.includes('appTrack') &&
              !location.pathname.includes('provider') &&
              isProvider(groups) &&
              !location.pathname.includes('payments') && (
                <div id="header-buttons-wrapper">
                  <Button
                    id="update-vouchers-button"
                    type="default"
                    className="ant-btn-primary"
                    label={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_PROVIDER_BUTTON_STATUS
                      ) || 'Ενημέρωση Voucher Status'
                    }
                    // label={'Ενημέρωση Voucher Status'}
                    disabled={false}
                    onClick={() => navigate('/appTrack/provider')}
                  />
                  <Button
                    id="payment-requests-button"
                    type="default"
                    className="ant-btn-primary submit-btn"
                    label={
                      getLocalString(
                        locales,
                        localNames?.HOME_PAGE_PROVIDER_BUTTON_PAYMENTS
                      ) || 'Αίτημα Πληρωμής'
                    }
                    // label={'Αίτημα Πληρωμής'}
                    disabled={false}
                    onClick={() => navigate('/appTrack/payments')}
                  />
                </div>
              )}
            {location.pathname.includes('provider') && isProvider(groups) && (
              <Button
                id="provider-submit-button"
                type="default"
                className="ant-btn-primary submit-btn"
                label={getLocalString(
                  locales,
                  localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                )}
                disabled={!providerFile}
                onClick={() => dispatch(openMassUploadSubmitModal(true))}
              />
            )}
            {location.pathname.includes('payments') && isProvider(groups) && (
              <Button
                id="payments-submit-button"
                type="default"
                className="ant-btn-primary submit-btn"
                label={getLocalString(
                  locales,
                  localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                )}
                disabled={!providerFile}
                onClick={() => dispatch(openMassUploadSubmitModal(true))}
              />
            )}
            {location.pathname.includes('mass-payments') && isKtP(groups) && (
              <Button
                id="mass-payments-submit-button"
                type="default"
                className="ant-btn-primary submit-btn"
                label={getLocalString(
                  locales,
                  localNames.REQUEST_PAGE_SUBMISSIONBUTTON
                )}
                disabled={!providerFile}
                onClick={() => dispatch(openMassUploadSubmitModal(true))}
              />
            )}
            {user.status !== null && user.status !== 400 && (
              <div id="logout" style={{ cursor: 'pointer' }}>
                <Logout visible={visible} setVisible={setVisible} user={user} />
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Header>
  );
};

export default HeaderGB;
